import React, { FC, ReactNode } from "react";
import { useStyles } from "./ChipStyles";
import { ChipProps } from "./types";

const computeBorderRadius = (rounded: ChipProps["rounded"]) => {
  switch (rounded) {
    case "small":
      return 2;
    case "medium":
      return 4;
    case "large":
      return 8;
    case "full":
      return 999;
    default:
      return 0;
  }
};

const Chip: FC<
  ChipProps & {
    icon?: ReactNode;
    action?: ReactNode;
  }
> = ({
  color = "#fff",
  fill = "#000",
  rounded = "full",
  icon,
  action,
  children,
  ...props
}) => {
  const styles = useStyles();

  return (
    <span
      className={styles.chipRoot}
      style={{
        backgroundColor: fill,
        color,
        borderRadius: computeBorderRadius(rounded),
      }}
      {...props}>
      <div className={styles.chipWrapper}>
        {icon}
        {children}
        {action}
      </div>
    </span>
  );
};

export default Chip;
